// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../nx/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../nx/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is marked as side effect in package.json to be included by SB  */

* {
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  scroll-behavior: smooth;
}

html {
  height: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  color: #2d2d2d;
  overflow-y: scroll;
}

html,
body {
  margin: 0;
  min-width: 320px;
  font-size: 1em;
  font-weight: 600;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ot-sdk-container {
  margin-left: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./public/global.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* This file is marked as side effect in package.json to be included by SB  */\n\n* {\n  box-sizing: border-box;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  scroll-behavior: smooth;\n}\n\nhtml {\n  height: 100%;\n  min-height: 100%;\n  background-color: #f6f6f6;\n  color: #2d2d2d;\n  overflow-y: scroll;\n}\n\nhtml,\nbody {\n  margin: 0;\n  min-width: 320px;\n  font-size: 1em;\n  font-weight: 600;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ot-sdk-container {\n  margin-left: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
